import React, { Component } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class Footer extends Component {
  render() {

    // eslint-disable-next-line
    const { children, ...attributes } = this.props;
    var dt = new Date();

    return (
      <React.Fragment>
        <span><a href="http://www.innates.my">INNATES</a> {dt.getFullYear()}</span>
        <span className="ml-auto">Powered by <a href="https://www.facebook.com/tess.utm/">IoT-Wave</a>&copy;</span>
      </React.Fragment>
    );
  }
}

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default Footer;



// WEBPACK FOOTER //
// ./src/components/sections/Footer/Footer.js